module.exports = __webpack_public_path__ + "static/kvm_7.38383b9c.jpg";